import React from 'react';
import { Box, Typography } from '@mui/material';
import emptyBox from '@images/icons/empty-box.jpg';

interface BoxEmptyProps {
  height?: string;
}

const BoxEmpty: React.FC<BoxEmptyProps> = (props) => {
  const { height = '70vh' } = props;

  return (
    <Box className='flexCenter' flexDirection='column' height={height}>
      <img src={emptyBox} width={200} alt='' />
      <Typography color='secondary.dark'>داده ایی یافت نشد!</Typography>
    </Box>
  );
};

export default BoxEmpty;
